import { connect } from 'react-redux'

import { FoodPartnerModal } from '@components/chef'

import coordinators from '@coordinators'
import presenters from '@presenters'
import services from '@services'
import { AppState } from '@models'
import { HandleError } from '@coordinators/composed'

const mapStateToProps = (state: AppState) => {
  const { lastLoggedInHq: currentHq } = state.user

  return {
    currentHq,
  }
}

const mapDispatchToProps = () => {
  const { RestService, ChefService, UIService } = services
  const { EditChef, ConfirmationModal } = UIService
  const {
    GetHubspotFoodPartner,
    NewManualChef,
    NewChefFromHubspot,
    CheckFoodPartnerLinked,
    LoadExistingChefs,
    ImportExistingChef,
  } = coordinators
  const {
    pResponseHubspotFoodPartnerWithContacts,
    createChefFromHubspot,
    pResponseChefs,
    pResponseChef,
  } = presenters.Api

  const getHubspotFoodPartner = GetHubspotFoodPartner({
    RestService,
    pResponseHubspotFoodPartnerWithContacts,
    HandleError,
  })

  const newManualChef = NewManualChef({
    ChefService,
    UIService,
  })

  const newChefFromHubspot = NewChefFromHubspot({
    ChefService,
    UIService,
    createChefFromHubspot,
  })

  const checkFoodPartnerLinked = CheckFoodPartnerLinked({
    RestService,
    HandleError,
  })

  const loadChefs = LoadExistingChefs({ RestService, pResponseChefs })
  const selectChef = ImportExistingChef({
    RestService,
    ChefService,
    UIService,
    pResponseChef,
    HandleError,
  })

  const close = EditChef.closeFoodPartnerModal

  return {
    close,
    confirmationModal: ConfirmationModal,
    checkFoodPartnerLinked,
    getHubspotFoodPartner,
    newManualChef,
    newChefFromHubspot,
    loadChefs,
    selectChef,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FoodPartnerModal)
